import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { getThumbnail } from '@src/common/utils';
import { formatImage } from '@src/common/formatImage';
import styles from './index.css';

class LargeVideo extends PureComponent {

    static propTypes = {
        content: PropTypes.array
    }

    render() {
        const { content } = this.props;
        const item = content[0];

        return (
            <div className={styles.videoWp}>
                <a href={item.url} target="_blank" rel="noreferrer" >
                    <img className={styles.poster} src={formatImage(getThumbnail(item), 1000, 620)} alt={item.title} />
                    <img className={styles.icon} src={require('../../assets/play.png')} alt="play" />
                </a>
            </div>
        );
    }
}

export default LargeVideo;
